import axios from "axios";

axios.defaults.withCredentials = true;

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/* Resolve relative image URLs (e.g. /api/static/products/foo.png) to absolute */
export const imgUrl = (u) => {
  if (!u) return u;
  if (u.startsWith("/api/static/") || u.startsWith("/static/")) {
    const path = u.startsWith("/api/") ? u : `/api${u}`;
    return `${BACKEND_URL}${path}`;
  }
  return u;
};

/* The user's Princess-and-the-Frog painted bayou artwork */
export const BAYOU_ART =
  "https://customer-assets.emergentagent.com/job_bubba-magic-rentals/artifacts/lup3nnvh_Untitled%20design.webp";
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_038dd044-0882-4ad4-9f01-4ae10a7a7ad4/artifacts/6lgbefi1_Logo.png";

/* Inject bayou art URL as a CSS variable so ::after backgrounds pick it up */
if (typeof document !== "undefined") {
  document.documentElement.style.setProperty("--bayou-art", `url("${BAYOU_ART}")`);
}
